import { UserFull } from '@wellesley/openapi'

export const isPublicChannel = (channel: Pick<UserFull, 'groupPrivacy'>) =>
  channel.groupPrivacy === 'PUBLIC'

export const isPrivateChannel = (channel: Pick<UserFull, 'groupPrivacy'>) =>
  channel.groupPrivacy === 'PRIVATE'
